<template>
  <i class="wx-emoji-icon" aria-hidden="true">
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="8.6" fill="none" stroke="currentColor" stroke-width="1.7" />
      <circle cx="9" cy="10" r="0.95" fill="currentColor" />
      <circle cx="15" cy="10" r="0.95" fill="currentColor" />
      <path
        d="M9.3 14.4A2.7 1.15 0 0 0 14.7 14.4"
        fill="none"
        stroke="currentColor"
        stroke-width="1.7"
        stroke-linecap="round"
      />
    </svg>
  </i>
</template>

<script>
export default {
  name: 'EmojiIcon'
}
</script>

<style scoped>
.wx-emoji-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  vertical-align: middle;
}

.wx-emoji-icon > svg {
  display: block;
  width: 1em;
  height: 1em;
}
</style>
